import React, { useEffect, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useSeller } from '../context/SellerContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SellerHeader from '../components/SellerHeader';
import SellerFooter from '../components/SellerFooter';
import FloatingMenu from '../components/FloatingMenu';

const ShopLayout = ({ cartCount }) => {
  const { seller, isSellerSite, loading, subdomain } = useSeller();

  // 파비콘은 SellerContext에서 관리 (중복 설정 제거)

  // 서브도메인이 있는데 로딩 중이라면 헤더를 숨김 (깜빡임 방지)
  if (subdomain && loading) {
    return <div className="shop-layout"></div>; 
  }

  return (
    <div className={`shop-layout ${isSellerSite ? 'seller-mode' : ''}`}>
      {isSellerSite ? <SellerHeader cartCount={cartCount} /> : <Header cartCount={cartCount} />}
      <FloatingMenu />
      <main className="main-content">
        <Suspense fallback={
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '80px 0' }}>
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
        }>
            <Outlet />
        </Suspense>
      </main>
      {isSellerSite ? <SellerFooter /> : <Footer />}
    </div>
  );
};

export default ShopLayout;
